import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { esCompartida } from './deviceModeStore.js';

// Quién está usando la tablet AHORA. No es una sesión: el dispositivo ya entró
// con su JWT y esto solo dice a nombre de quién se registran las comandas y las
// propinas del turno, para no cerrar sesión cada vez que cambia el mesero.
//
// Se persiste porque una recarga de la app no debería obligar a todo el equipo
// a volver a teclear su PIN. Se limpia al cerrar caja.
//
// En una tablet compartida además se suelta sola al terminar con una mesa: sin
// eso, quien teclea su PIN en la mañana queda como el mesero de TODO el día, y
// las propinas del turno entero se le acreditan a él.
export const useWaiterStore = create(
  persist(
    (set) => ({
      waiter: null,          // { _id, name, role }
      setWaiter: (waiter) => set({ waiter: waiter ?? null }),
      clearWaiter: () => set({ waiter: null }),

      // Suelta la identidad al terminar con una mesa. Solo aplica en las
      // tablets marcadas como compartidas: en la del gerente, o en el celular
      // de un mesero, pedir el PIN a cada rato sería estorbo puro.
      soltarSiCompartida: () => {
        if (esCompartida()) set({ waiter: null });
      },
    }),
    { name: 'gc-pos-waiter' }
  )
);

export const waiterId = () => useWaiterStore.getState().waiter?._id ?? null;
